import { forwardRef, Ref, type SVGProps } from 'react';

const SvgProjectsIcon = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 27 29"
    ref={ref}
    {...props}
  >
    <g fill="currentColor" clipPath="url(#projects-icon_svg__a)">
      <path d="M3.49 14.77v2.416l13.791.005v-2.417z" />
      <path d="m5.113 9.309-1.208 2.093 11.864 6.855 1.209-2.093z" />
      <path d="m5.162 9.666.593 2.065L0 11.148zM3.389 15.305l1.666 1.356L0 19.47zM5.59 20.676l2.086.518-3.38 4.694z" />
      <path d="m6.683 19.602.706 2.029-5.778-.262zM5.188 15.306l-1.074 1.86-3.577-4.545zM6.303 10.062l-1.7 1.699-2.548-5.948zM8.305 4.509l-.622 2.32L2.5 2.955z" />
      <path d="m9.784 6.34-2.322.622L8.23.537zM5.188 20.112l1.208 2.093 11.124-6.418-1.208-2.093z" />
      <path d="M9.268 5.204 7.175 6.412l6.563 11.376 2.093-1.209z" />
      <path d="M18.274 9.398H9.95V29h8.324z" />
      <path d="M16.609 5.805c5.487 0 9.935 4.568 9.935 10.204 0 5.635-4.448 10.204-9.935 10.204z" />
      <path d="M11.815 0c5.042 0 9.13 4.027 9.13 8.995s-4.088 8.996-9.13 8.996z" />
    </g>
    <defs>
      <clipPath id="projects-icon_svg__a">
        <path fill="currentColor" d="M0 0h26.742v29H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgProjectsIcon);
export default ForwardRef;
